import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { PortalService } from '../../../core/services/portal.service';
import { Portal } from '../../../core/models/portal.model';

@Component({
  selector: 'brn-nav-brand',
  templateUrl: './nav-brand.component.html',
  styleUrls: ['./nav-brand.component.scss'],
})
export class NavBrandComponent implements OnInit {
  portalSettings: Portal;

  constructor(public location: Location) {
    this.portalSettings = PortalService.Settings;
  }

  ngOnInit(): void {}
}
